import { Button } from '@/components/ui/button';
import { toastSomethingError } from '@/components/ui/toast-content';
import siteConfig from '@/config';
import PATH_PAGE from '@/router/path';
import { addDailyCreditUsage } from '@/service/payment';
import { useGetCreditBalanceSummaryOption } from '@/service/payment/hook';
import { useMutation, useQuery } from '@tanstack/react-query';
import { GiftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';

const ViewCreditMini = () => {
  const {
    data,
    refetch: refetchCredit,
    isLoading: isLoadingCredit,
    isSuccess,
  } = useQuery({
    ...useGetCreditBalanceSummaryOption(),
  });

  const mutateAddDailyCreditUsage = useMutation({
    mutationFn: async () => {
      const res = await addDailyCreditUsage();
      return res;
    },
    onSuccess: () => {
      refetchCredit();
      toast.success('Claim daily free credit successfully');
    },
    onError: (err) => {
      toastSomethingError(err);
    },
  });

  const handleClaimDailyFreeCredit = async () => {
    mutateAddDailyCreditUsage.mutate();
  };

  const totalAvailableCredit = data?.balances?.[0]?.available_balance?.monetary
    ?.value
    ? Number(data.balances[0].available_balance.monetary.value) / 100
    : 0;

  return (
    <>
      {
        siteConfig.other.claimDailyFreeCredit &&
          isSuccess &&
          totalAvailableCredit <= 0 && (
            <>
              <Button
                variant={'outline'}
                className="h-8 rounded-full p-4 text-xs"
                onClick={handleClaimDailyFreeCredit}
                disabled={mutateAddDailyCreditUsage.isPending}
                // startIcon={<GiftIcon className="h-4 w-4" />}
              >
                🎁 &nbsp;Claim Daily Credit
              </Button>
            </>
          )
        // : (
        //   <>
        //     <Link to={PATH_PAGE.setting.payment}>
        //       <Button
        //         variant={'secondary'}
        //         className="h-8 rounded-full p-4 text-xs"
        //       >
        //         You already have free credit
        //       </Button>
        //     </Link>
        //   </>
        // )
      }
    </>
  );
};

export default ViewCreditMini;
